<mat-card>
  <h2 matDialogTitle class="mat-h2" style="padding-left: 16px;">Copy Discount Tracking Link</h2>
  <mat-card-content>
    <mat-divider style="margin-bottom: 8px;"></mat-divider>
    <p mat-card-subtitle>Use this link to earn commission.</p>

    <div>
      <div class="tracking-link-container">
        <mat-form-field appearance="fill" style="flex: 1" [style.display]="isTrackingLinkLoading() ? 'none' : null">
          <mat-label>Tracking Link</mat-label>
          <input matInput readonly [value]="(trackingLink$ | async)" #trackingLinkInput>
        </mat-form-field>
        @if (isTrackingLinkLoading()) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
      </div>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Tracking Link Settings
          </mat-panel-title>
        </mat-expansion-panel-header>

          <mat-form-field floatLabel="always">
            <mat-label>Affiliate Website</mat-label>
            <mat-select [formControl]="affiliateWebsiteControl">
              @for(option of (affiliateWebsites$ | async); track option.affiliate_website_id) {
                <mat-option [value]="option">
                  {{option.affiliateWebsiteUrlStripped}}
                </mat-option>
              }
            </mat-select>
            <mat-hint>
              Select the website to associate clicks to
            </mat-hint>
          </mat-form-field>

          <mat-form-field floatLabel="always">
            <mat-label>Custom Tracking Code</mat-label>
            <input matInput placeholder="Enter Text (Optional)" [formControl]="customTrackingCodeControl">
            <mat-hint>Click parameter associated to this link</mat-hint>
            <mat-error>{{customTrackingCodeControl.errors | validationMessage}}</mat-error>
          </mat-form-field>
          <div>
            <mat-checkbox [formControl]="urlShorteningControl">Shorten URL</mat-checkbox>
          </div>
      </mat-expansion-panel>
    </div>
  </mat-card-content>

  <mat-card-actions class="actions-with-social-shares">
    <div class="social-button-group">
      <img [ngSrc]="'/assets/images/facebook-share.png' | absUrl" (click)="onSocialShareClick('facebook')" width="76" height="28">&nbsp;
      <img [ngSrc]="'/assets/images/x-share.png' | absUrl" (click)="onSocialShareClick('twitter')" width="89" height="28">
    </div>

    <div class="copy-button-group">
      <button mat-button class="white" mat-dialog-close>Cancel</button>
      <button mat-raised-button color="primary" cdkFocusInitial (click)="onCopyClick(trackingLinkInput.value)">Copy</button>
    </div>
  </mat-card-actions>
</mat-card>
